export const translate = (key) => global.LitiumTexts[key] || key;
